import {AfterViewInit, Component, inject, Input} from '@angular/core';
import {MriBulkDownloadService} from '@features/transactions/external-accounts/mri/mri-bulk-download.service';
import {CrudTableComponent} from '@ui-webkit/components/crud-table/crud-table.component';
import {
  MRIReportDataItem,
  MRIReportRequest
} from '@features/transactions/external-accounts/mri/mri-bulk-download.model';
import {LoadingService} from '@ui-kit/utils/service/loading.service';
import {Observable} from 'rxjs';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatOption, MatSelect} from '@angular/material/select';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {AsyncPipe, NgForOf} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';

@Component({
  standalone: true,
  templateUrl: './mri-bulk-download.component.html',
  selector: 'app-mri-bulk-download',
  imports: [
    CrudTableComponent,
    FlexLayoutModule,
    MatFormFieldModule,
    MatSelect,
    ReactiveFormsModule,
    MatOption,
    NgForOf,
    MatButtonModule,
    AsyncPipe
  ]
})
export class MRIBulkDownloadComponent implements AfterViewInit {
  @Input() selectedMonth!: number;
  @Input() selectedYear!: number;
  @Input() reload!: Observable<void>;
  mriReport: MRIReportDataItem[] = [];
  parentCompanies: { name: string, value: string }[] = [];
  protected readonly mriBulkDownloadType = MRIReportDataItem;
  private _loader = inject(LoadingService);
  protected loading$ = this._loader.loading$;
  private mriBulkDownloadService = inject(MriBulkDownloadService);
  parentCompanyCtrl = new FormControl<string[]>([]);

  constructor() {
  }

  ngAfterViewInit(): void {
    this.loadReport(true);
    this.reload.subscribe(() => {
      setTimeout(() => {
        this.loadReport(true);
      }, 500);
    });
  }

  runFilter(): void {
    this.loadReport(false);
  }

  loadReport(init: boolean = false): void {
    let request: MRIReportRequest = {
      month: this.selectedMonth,
      year: this.selectedYear,
      parentCompanyNames: this.parentCompanyCtrl?.value ? this.parentCompanyCtrl.value : []
    }
    this.mriBulkDownloadService.loadReport(request).subscribe({
        next: response => {
          this.mriReport = response;
          if (init) {
            this.generateParentCompanyFilter();
          }
        },
        error: error => {
          console.error(error);
        }
      }
    );
  }

  generateParentCompanyFilter(): void {
    const uniqueParentCompanies = new Set(this.mriReport.map(item => item.parentCompanyName));
    this.parentCompanies = [];
    if (uniqueParentCompanies.has(null)) {
      this.parentCompanies.push({name: 'Your space', value: 'NO_PARENT'});
    }
    uniqueParentCompanies.forEach(company => {
      if (company) {
        this.parentCompanies.push({name: company, value: company});
      }
    });
  }

}
